/* eslint-disable max-len */
import React from 'react';
function AddCourseOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.9 2.9 2 4 2C4 2 3.5 2.5 3.5 3V4V21V22C3.5 22.5 4 23 4 23C2.75067 22.6214 2.24372 22.2419 2 21V4ZM18 2H7C5.9 2 5 2.9 5 4V21C5 22.1 5.9 23 7 23H14V21H7V4H18V13H20V4C20 2.9 19.1 2 18 2ZM16 7H9V9H16V7ZM9 11H14V13H9V11ZM19.9999 19.875V23H17.9999V19.875H15V18H17.9999V15H19.9999V18H22.9999V19.875H19.9999Z" })));
}
export default AddCourseOutlined;
